import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './FeatureCardsList.css';
import React, { useEffect, useState, useContext, useRef } from 'react';
import throttle from 'lodash/throttle';
import { canUseDOM, get, getColorByTheme, getDictionaryItem, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../resources/icons/IconChevronLeftLight.svg';
import LazyPicture from '../atoms/LazyPicture';
import ScrollAnimation from 'react-animate-on-scroll';
import RouterLink from '../atoms/RouterLink';
import FeatureCardItem from './FeatureCardItem';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
export var FeatureCardsList = function FeatureCardsList(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var carousel = params !== undefined && params['Is Carousel'] === '1';
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var carouselWrapperRef = useRef(null);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    introHeight = _useState4[0],
    setIntroHeight = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    titleHeight = _useState6[0],
    setTitleHeight = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    ctaHeight = _useState8[0],
    setCtaHeight = _useState8[1];
  var _useState9 = useState(canUseDOM && window.matchMedia("(max-width: 767px)").matches),
    _useState10 = _slicedToArray(_useState9, 1),
    mobileDevice = _useState10[0];
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var countHeights;
  if (canUseDOM) {
    countHeights = throttle(function () {
      if (carouselWrapperRef.current) {
        var _titleHeight = 0,
          _introHeight = 0,
          btnHeight = 0;
        var titlesList = carouselWrapperRef.current.querySelectorAll('.title');
        var introsList = carouselWrapperRef.current.querySelectorAll('.description');
        var ctaBlock = carouselWrapperRef.current.querySelectorAll('.btn-tertiary.btn-tertiary--carousel');
        titlesList.forEach(function (title) {
          var height = title.offsetHeight;
          if (_titleHeight < height) _titleHeight = height;
        });
        introsList.forEach(function (intro) {
          var height = intro.offsetHeight;
          if (_introHeight < height) _introHeight = height;
        });
        ctaBlock.forEach(function (btn) {
          var height = btn.offsetHeight;
          if (btnHeight < height) btnHeight = height;
        });
        setTitleHeight(_titleHeight);
        setIntroHeight(_introHeight);
        setCtaHeight(btnHeight);
      }
    }, 300);
  }
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return function () {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(function () {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  if (!fields) {
    console.info('FeatureCardsList component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[FeatureCardsList component is empty: please provide data source]");
    }
    return null;
  }
  var items = get(fields, 'data.item.cards.items', []);
  if (items.length < 2) return null;
  var dictionaryValues = get(fields, 'data.dictionary');
  var readmore = getDictionaryItem(dictionaryValues, 'ReadMore');
  var itemsToShow = items.length > 2 ? 3 : 2;
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex', getColorByTheme(BackgroundColorHex));
  var ActiveColorHex = get(params, 'ActiveColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var styleThemeHexColor = BackgroundColorHex ? {
    '--m10-profile-cards-background-color': BackgroundColorHex,
    '--m10-profile-cards-background-active-color': ActiveColorHex,
    '--m10-profile-cards-color': ColorHex
  } : {
    '--m10-profile-cards-background-color': selectedPrimaryColor,
    '--m10-profile-cards-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m10-profile-cards-color': getColorByTheme(selectedPrimaryColor)
  };
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderTileItems = function renderTileItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        key: "$article-carousel-tile-".concat(index)
      }, /*#__PURE__*/React.createElement(FeatureCardItem, _extends({}, item, {
        readmore: readmore,
        itemsToShow: itemsToShow,
        mobileDevice: mobileDevice,
        eventsAnalytics: eventsAnalytics,
        params: params
      })));
    });
  };
  var renderTileGridItems = function renderTileGridItems() {
    return items.map(function (item, index) {
      var title = get(item, 'title.jss');
      var description = get(item, 'description.jss');
      var hasDescription = get(item, 'description.jss.value');
      var hasTitle = get(item, 'title.jss.value');
      var image = get(item, 'image.jss.value.src');
      var alt = get(item, 'image.jss.value.alt');
      var CtaHref = get(item, 'cTALink.jss.value.href');
      var CtaTarget = get(item, 'cTALink.jss.value.target');
      var CtaLinktype = get(item, 'cTALink.jss.value.linktype');
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        className: "col-lg-6 grid-item-col",
        animateOnce: true,
        duration: 1 + index / 3,
        key: "$article-carousel-tile-".concat(index)
      }, /*#__PURE__*/React.createElement(RouterLink, {
        className: "grid-item",
        href: CtaHref,
        linktype: CtaLinktype,
        linksTarget: CtaTarget
      }, /*#__PURE__*/React.createElement("div", {
        className: "image-grid-container",
        onClick: function onClick() {
          return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title.value]);
        }
      }, image && /*#__PURE__*/React.createElement(LazyPicture, {
        className: "picture",
        hover: true
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: "".concat(injectImageResolution(image, 500, 500))
      }), /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: "".concat(injectImageResolution(image, 750, 750))
      }), /*#__PURE__*/React.createElement("img", {
        src: "".concat(injectImageResolution(image, 575, 575)),
        alt: alt
      }))), /*#__PURE__*/React.createElement("div", {
        className: "text-grid-container",
        onClick: function onClick() {
          return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title.value]);
        }
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, hasTitle && /*#__PURE__*/React.createElement(Text, {
        tag: "h2",
        className: "title-grid",
        field: title
      })), /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, hasDescription && /*#__PURE__*/React.createElement(Text, {
        tag: "p",
        className: "description-grid",
        field: description
      })), /*#__PURE__*/React.createElement("div", {
        className: "cta-wrapper-grid",
        onClick: function onClick(e) {
          e.stopPropagation();
          tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), [title.value, readmore]);
        }
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, CtaHref && /*#__PURE__*/React.createElement(RouterLink, {
        className: "btn-tertiary btn-tertiary--carousel",
        title: 'Read more',
        href: CtaHref,
        linktype: CtaLinktype,
        linksTarget: CtaTarget
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn-tertiary__text"
      }, readmore), rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null)))))));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: styleThemeHexColor
  }, carousel ? /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--intros-height': introHeight,
      '--titles-height': titleHeight,
      '--cta-height': ctaHeight
    }
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots,
      state = _ref2.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['sliderAnalytics'], params), ['previous']);
    }, true, false), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['sliderAnalytics'], params), ['next']);
    }, true, false)), renderCarousel(renderTileItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: itemsToShow
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: itemsToShow
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params));
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, renderTileGridItems())));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var commonStyles = "cll839h";
var ltrStyles = "l1hzp8u0";
var rtlStyles = "rxs1oo7";
export default FeatureCardsList;